export default __webpack_public_path__ + "static/media/no_image.e1ce751e.jpg";